<h2 mat-dialog-title class="popup-header">Select Fluid Flow Model</h2>

<div class="popup-content">
  @if (fluidModels.length > 0) {
    <div class="scroll">
      <table class="mat-elevation-z2 full-width">
        <thead>
          <tr>
            <th>Name</th>
            <th>Selected<br/>direction</th>
            <th>Flow units</th>
            <th>Interfacial<br/>tension<br/>Interval</th>
            <th>Contact<br/>angle<br/>Interval<br/>(PD)</th>
            <th>Contact<br/>angle<br/>Interval<br/>(FI)</th>
          </tr>
        </thead>
        <tbody>
          @for (model of fluidModels; track model) {
            <tr
              (click)="onRowClick(model)"
              [class.selected]="model.id === selectedFluidModel?.id"
              >
              <td>{{ model.name }}</td>
              <td>{{ model.direction }}</td>
              <td>{{ model.flowUnits }}</td>
              <td>{{ formatRange(model.interfactialTension.min, model.interfactialTension.max) }}</td>
              <td>{{ formatRange(model.primaryDrainage.min, model.primaryDrainage.max) }}</td>
              <td>{{ formatRange(model.firstImbibition.min, model.firstImbibition.max) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="no-results">
      <mat-icon class="no-results-icon">info</mat-icon>
      <p>No fluid flow models available for the selected rock model.</p>
    </div>
  }
</div>

<div class="popup-actions">
  <button class="btn btn-secondary" (click)="closeDialog()">Cancel</button>
  <button class="btn btn-primary" [disabled]="!selectedFluidModel" (click)="selectFluidModel()">
    Select
  </button>
</div>
